import { Button, Group, Modal, Text } from '@mantine/core';
import { useIntl } from 'react-intl';

interface DeleteFileModalProps {
  opened: boolean;
  onClose: () => void;
  fileName: string;
  onConfirm: () => void;
}

export const DeleteFileModal = ({
  opened,
  onClose,
  fileName,
  onConfirm,
}: DeleteFileModalProps) => {
  const intl = useIntl();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`${intl.formatMessage({ id: 'delete' })} ${intl.formatMessage({ id: 'file' }).toLowerCase()}`}
      centered
    >
      <Text size="sm">
        {intl.formatMessage({ id: 'areYouSureYouWantToDelete' })}{' '}
        <strong>{fileName}</strong>?
      </Text>
      <Text size="sm" c="red" mt="xs" fw={500}>
        {intl.formatMessage({ id: 'thisActionIsIrreversible' })}.
      </Text>

      <Group justify="flex-end" mt="md">
        <Button variant="subtle" onClick={onClose}>
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button color="red" onClick={handleConfirm}>
          {intl.formatMessage({ id: 'delete' })}
        </Button>
      </Group>
    </Modal>
  );
};
